import { useEffect } from "react";
import ownerphoto from "../../images/ownerphoto.jpg";
import logo from "../../images/rrlogoicon.png";
import styles from "./AboutUs.module.css";

const AboutUs = () => {
  useEffect(() => {
    document.title = "Rest and Relax";
  }, []);

  return (
    <div className="w-[80%]">
      <div className="flex flex-col items-center justify-center text-xl md:text-3xl text-center text-secondary mx-auto">
        <h2 className="heading-xl">about us</h2>
        <div className="mb-16 mt-8 w-[100px]">
          <img className="self-center" src={logo} alt="our logo"></img>
        </div>
        <p className="text-black">
          Rest and Relax Vacation LLC is a family-owned business providing beach
          front vacation experiences since 2002.
        </p>
        <br></br>
        <div className="flex flex-col align-middle justify-center mb-8">
          <blockquote className={styles.fancyQuote}>
            <p className="text-left">
              The business began when I wanted to find a place where my family
              could create memories of our time together. When my kids were
              young, we always preferred to stay in a home rather than a hotel
              as it was easier to prepare our own food. Now that my kids are all
              grown, I hope future guests will be able to create wonderful
              memories as well.
            </p>
            <br></br>
            <p className="text-left">
              I always appreciate a well furnished home that is kid friendly,
              easy to cook in, and has comfortable beds. I strive to treat our
              guests how I like to be treated.
            </p>
          </blockquote>
          <img
            className="w-[30%] md:w-[20%] self-center rounded-full mb-2"
            src={ownerphoto}
          ></img>
          <p className="text-2xl md:text-4xl text-black"> Veronica </p>
          <p className="text-lg md:text-2xl text-black">
            <i>Owner</i>
          </p>
        </div>
      </div>

      {/* TODO MOVE CONTACT ROUTE */}
    </div>
  );
};

export default AboutUs;
